var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.837 3.176a.527.527 0 00-.785 0L8 7.55 3.948 3.176a.527.527 0 00-.785 0 .634.634 0 000 .848l4.444 4.8a.527.527 0 00.786 0l4.444-4.8a.635.635 0 000-.848z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.837 7.176a.527.527 0 00-.785 0L8 11.552 3.948 7.176a.527.527 0 00-.785 0 .634.634 0 000 .848l4.444 4.8a.527.527 0 00.786 0l4.444-4.8a.635.635 0 000-.848z",
    fill: "#fff"
  })));
}

export default SvgDoubleArrowDown;